import { render, staticRenderFns } from "./ModalLanguageDropdown.vue?vue&type=template&id=76dc9727&scoped=true&"
import script from "./ModalLanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./ModalLanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ModalLanguageDropdown.vue?vue&type=style&index=0&id=76dc9727&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dc9727",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
